// extracted by mini-css-extract-plugin
export default {"section":"burger-constructor_section__Pu2Q7"};